/**
 * Manages scroll-based animations and back-to-top functionality
 */
export class AnimationManager {
  /**
   * Initialize all animation observers and handlers
   */
  initialize() {
    this.setupScrollAnimations()
    this.setupBackToTop()
  }

  /**
   * Setup IntersectionObserver for scroll-triggered animations
   * @private
   */
  setupScrollAnimations() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.triggerAnimation(entry.target)
          observer.unobserve(entry.target)
        }
      })
    }, observerOptions)

    const animatedElements = document.querySelectorAll(
      '.animated-pulse, .animated-pull-up, .animated-fade-in'
    )
    
    animatedElements.forEach(el => observer.observe(el))
  }

  /**
   * Trigger the appropriate animation on an element
   * @private
   */
  triggerAnimation(element) {
    const animationMap = {
      'animated-pulse': 'pulse',
      'animated-pull-up': 'pull-up',
      'animated-fade-in': 'fade-in'
    }

    for (const [animatedClass, activeClass] of Object.entries(animationMap)) {
      if (element.classList.contains(animatedClass)) {
        element.classList.add(activeClass)
        element.classList.remove(animatedClass)
        break
      }
    }
  }

  /**
   * Setup back-to-top button visibility toggle
   * @private
   */
  setupBackToTop() {
    const backToTop = document.getElementById('back_to_top')
    
    if (!backToTop) return

    backToTop.style.display = 'none'
    
    window.addEventListener('scroll', () => {
      backToTop.style.display = window.scrollY > 800 ? 'block' : 'none'
    })
  }
}
